import React, { useEffect, Suspense } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import { Provider } from "react-redux";
import "./App.css";

import { DataProvider } from "../hooks/data/DataProvider";

import { AuthProvider, useAuth } from "../hooks/auth/AuthContext";

import Login from "../login/Login";
import ProfilePage from "../login/ProfilePage";

import MainLayout from "../layouts/MainLayout";
import IDELayout from "../layouts/IDELayout";
import FullPageLoader from "./FullPageLoader";
import ErrorBoundary from "./ErrorBoundary";

import { LanguageProvider } from "../components/language/LanguageContext";
import { LabAccessProvider } from "../contexts/LabAccessContext";
import ThemeProvider from "react-bootstrap/ThemeProvider";
import store from "../hooks/data/redux_data/store";

import DownloadSecured from '../components/DownloadSecured';

import HomePage from "../pages/home/HomePage";
import ProgramPage from "../pages/program/ProgramPage";
import CompetitionsPage from "../pages/competition/CompetitionsPage";
import FounderPage from "../pages/founder/FounderPage";
import AboutPage from "../pages/about/AboutPage";
import PlatformPage from "../pages/platform/PlatformPage";
import AchievementPage from "../pages/achievement/AchievementPage";
import CommunityPage from "../pages/community/CommunityPage";

import HtmlRenderer from "../pages/HtmlRenderer";
import MediaWikiComp from "../pages/home/MediaWikiComp";
import NewsList from "../pages/news/NewsList";
import NewsPage from "../pages/news/NewsPage";
import Dashboard from "../pages/dashboard/Dashboard";
import AdminDashboard from "../pages/admin/AdminDashboard.jsx";
import AdminIDERequests from "../pages/admin/AdminIDERequests";



import IDE from "../pages/IDE.jsx";

//import IDE from "../pages/IDE_old";
import SelectIDE from "../pages/SelectIDE";
import AccessRequired from "../pages/AccessRequired";
import PrivateRoute from "../routes/PrivateRoute";
import LabPage from "../pages/lab/index";
import LabPage2 from "../pages/lab/LabPage";
import LabLoaderPage from "../pages/LabLoaderPage";
import LabForm from "../form/LabForm";
import ProgramForm from "../form/ProgramForm";
import Donation from "../pages/Donation";
import DonationSuccess from "../pages/DonationSuccess";
import DonationCancelled from "../pages/DonationCancelled";
import Sponsor from "../pages/Sponsor";
import CubeSatLab from "../pages/CubeSatLab";
import CubeSatTelemetry from "../pages/CubeSatTelemetry";
import ContentEditorModal from "../pages/ContentEditorModal";
import Simulation from "../pages/Simulation";
import MetroMissionControl from "../pages/MetroMissionControl";
import SpaceBioMissionControl from "../pages/SpaceBioMissionControl";
import MissionResults from "../pages/MissionResults";
import Signup from "../pages/business/Signup";
import Pricing from "../pages/business/Pricing";
import BillingCheckout from "../pages/business/BillingCheckout";
import BillingSuccess from "../pages/business/BillingSuccess";
import Contact from "../pages/business/Contact";
import ApplicationForm from "../pages/ApplicationForm";
import HackathonApplication from "../pages/hackathon/HackathonApplication";

import AdminGameProjects from "../admin/AdminGameProjects";
import AdminSimulation from "../admin/AdminSimulation";
import AdminIDE from "../admin/AdminIDE";

import Projects from "../pages/project/Projects";
import StudentDashboard from "../pages/dashboard/StudentDashboard";

import DocumentViewer from "../pages/DocumentViewer";

import SimulationVisualization from "../ide/SimpleIDE/SimpleIDESimulation.jsx"

function LabFormWrapper() { const { labId } = useParams(); return <LabForm labId={labId} />; }
function ProgramFormWrapper() { const { programId } = useParams(); return <ProgramForm programId={programId} />; }

function AppContent() {
  const { user } = useAuth();

  return <div style={{ backgroundColor: "#000" }}>
    <div style={{ paddingTop: "60px" }} />
    <ErrorBoundary>
      <Suspense fallback={<FullPageLoader />}>
        <Routes>


          <Route path="/" element={<MainLayout><HomePage user={user} /></MainLayout>} />
          <Route path="/rect/dow/" element={<MainLayout><DownloadSecured user={user} /></MainLayout>} />

          <Route path="/rect/*" element={<MainLayout>
            <Routes>
              <Route path="login" element={<Login />} />
              <Route path="app/labs/signup" element={<Signup />} />
              <Route path="profile" element={<ProfilePage />} />

              <Route path="/about" element={<AboutPage user={user} />} />
              <Route path="/founder" element={<FounderPage user={user} />} />
              <Route path="/programs" element={<ProgramPage user={user} />} />
              <Route path="/competitions" element={<CompetitionsPage user={user} />} />
              <Route path="labs" element={<LabPage user={user} />} />
              <Route path="labs/:labId" element={<LabPage2 user={user} />} />
              <Route path="/platform" element={<PlatformPage user={user} />} />
              <Route path="/achievements" element={<AchievementPage user={user} />} />
              <Route path="/community" element={<CommunityPage user={user} />} />



              <Route path="docviewer" element={<DocumentViewer user={user} />} />

              <Route path="labs/loader/:projectId/:labId/:ideType/:level" element={<DataProvider><LabLoaderPage /></DataProvider>} />
              <Route path="/app/student-dashboard" element={<StudentDashboard />} />
              {/* <Route path="/app/projects" element={<Projects/>}/> */}
              <Route path="/app/projects/:labId" element={<DataProvider><Projects /></DataProvider>} />

              <Route path="html/:contentId" element={<HtmlRenderer />} />
              <Route path="wiki/:pageTitle" element={<MediaWikiComp />} />

              <Route path="ide/select/:lab_id" element={<SelectIDE mode="simple" />} />
              <Route path="ide/access-required" element={<AccessRequired />} />

              <Route path="admin/ide/requests" element={<PrivateRoute role="admin"><AdminIDERequests /></PrivateRoute>} />
              <Route path="admin" element={<PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>} />
              <Route path="dash" element={<Dashboard user={user} />} />

              <Route path="space/news/*" element={<NewsList />} />
              <Route path="media/*" element={<NewsPage />} />

              <Route path="lab/new" element={<LabForm />} />
              <Route path="lab/edit/:labId" element={<LabFormWrapper />} />
              <Route path="program/new" element={<ProgramForm />} />
              <Route path="program/edit/:programId" element={<ProgramFormWrapper />} />

              <Route path="donation" element={<Donation />} />
              <Route path="donation/success" element={<DonationSuccess />} />
              <Route path="donation/cancelled" element={<DonationCancelled />} />
              <Route path="sponsor" element={<Sponsor />} />

              <Route path="cubesat/lab" element={<CubeSatLab />} />
              <Route path="cubesat/telemetry" element={<CubeSatTelemetry />} />
              <Route path="cubesat/editor/model" element={<ContentEditorModal />} />

              <Route path="monitor/mission/control" element={<MetroMissionControl />} />
              <Route path="space/mission/control" element={<SpaceBioMissionControl />} />

              <Route path="app/labs/pricing/:labId" element={<Pricing />} />
              <Route path="app/labs/billing/checkout" element={<BillingCheckout />} />
              <Route path="app/labs/billing/success" element={<BillingSuccess />} />

              <Route path="/events/:eventId/application" element={<HackathonApplication user={user} />} />

              <Route path="labs/:labId/results" element={<MissionResults user={user} />} />

              <Route path="contact" element={<Contact />} />
              <Route path="aplication" element={<ApplicationForm />} />

              <Route path="/admin/game-projects/:labId" element={<AdminGameProjects />} />
              <Route path="/admin/simulation" element={<AdminSimulation />} />
              <Route path="/admin/ide/:projectType/:projectId" element={<AdminIDE />} />
              <Route path="/ide/vis/" element={<SimulationVisualization />} />


            </Routes>
          </MainLayout>} />

          <Route path="/rect/ide/:lab_id/:projectId" element={<IDELayout><DataProvider><IDE mode="simple" /></DataProvider></IDELayout>} />
          <Route path="/rect/simulation/:lab_id/:projectId" element={<Simulation />} />


        </Routes>
      </Suspense>
    </ErrorBoundary>
  </div>;
}

export default function App() {
  // useEffect(()=>{
  //   async function loadCSS(){
  //     try{
  //       const res=await fetch("/api/html/css");
  //       if(!res.ok)return;
  //       const data=await res.json();
  //       let style=document.getElementById("dynamic-css");
  //       if(!style){
  //         style=document.createElement("style");
  //         style.id="dynamic-css";
  //         document.head.appendChild(style);
  //       }
  //       style.innerHTML=data.html;
  //     }catch(err){console.error("Dynamic CSS loading error:",err);}
  //   }
  //   loadCSS();
  // },[]);

  return <ThemeProvider theme="dark">
    <LanguageProvider>
      <Provider store={store}>
        <AuthProvider>
          <LabAccessProvider>
            <AppContent />
          </LabAccessProvider>
        </AuthProvider>
      </Provider>
    </LanguageProvider>
  </ThemeProvider>;
}